<template>
  <div id="sitet" style="background: transparent">
    <div class="container">
      <div class="row">
        <div class="col-md-3">
          <h1 class="mb-3">{{ this.title }}</h1>
        </div>
        <div class="col-md-12 align-self-center">
          <h1 class="mb-3" style="margin-top: 10px">Termos de Uso</h1>
          <p>
            Você está acessando o Portal de Negociação do Tribanco (doravante
            “Portal”) do Banco Triângulo S/A, pessoa jurídica de direito
            privado, estabelecido na cidade de Uberlândia-MG, na Avenida Cesário
            Alvim, 2209, bairro Aparecida, inscrito no CNPJ sob o nº
            17.351.180/0001-59 (doravante “Tribanco”). Obrigado por acessar o
            nosso Portal. Para sua segurança, a navegação no Portal está sujeita
            a regras e condições diversas. Você só poderá navegar no nosso
            Portal se aceitar expressamente tais regras e condições, que
            passamos a expor. O Portal é uma ferramenta desenvolvida pelo
            Tribanco que visa aproximar credores e possíveis devedores, lhes
            permitindo a consulta da existência de eventuais débitos não
            quitados, ofertando aos devedores cadastrados meios para pagamento
            de forma facilitada.
          </p>
          <h3>I – O Portal e condições de navegação</h3>
          <p>
            Ao acessar o Portal, Você concorda que terá acesso a um banco de
            dados cuja titularidade autoral é de terceiros e, nestas condições,
            Você concorda em não altera-lo ou modifica-lo e, quanto ao Portal,
            está ciente de que é vedado realizar ou permitir engenharia reversa,
            traduzir, decompilar, copiar, modificar, reproduzir, alugar,
            sublicenciar, publicar, divulgar, transmitir, emprestar, distribuir
            ou, de outra maneira, dispor das ferramentas de consulta deste
            Portal e de suas funcionalidades ou utilizar dele para outros fins
            que não sejam aqueles já indicados nestes Termos. Você também
            declara ter ciência de que é vedada a utilização de aplicativos
            spider ou de mineração de dados, de qualquer tipo ou espécie, além
            de outro aplicativo ou recurso que atue de modo automatizado para
            realizar operações massificadas ou para quaisquer outras
            finalidades, sob pena de responder pelos danos verificados. Para
            navegar em nosso Portal Você está ciente que deverá disponibilizar
            os meios necessários, tais como equipamentos de informática
            (tablets, computadores, celular, etc) munidos de internet. II – Como
            funciona o Portal O Portal é de titularidade do Tribanco e, nestas
            condições, Você concorda que ele poderá alterar a exibição de
            informações e, de maneira geral, o layout do Portal. Eventualmente,
            por razões diversas, o Portal pode estar indisponível, o que não
            ensejará a Você o direito de qualquer indenização ou reparação. O
            Tribanco aplicará todos os seus melhores esforços para que o Portal
            esteja acessível a todo o tempo. Não obstante, Você reconhece que em
            função de manutenção (corretiva e preventiva) ou fatos
            extraordinários ao interesse do Tribanco, inclusive casos fortuitos
            ou de força maior, o Portal poderá estar inacessível. Como a
            finalidade do Portal é a aproximação do credor e devedor, oferecendo
            uma oportunidade de encerramento do débito havido, o Tribanco não se
            responsabiliza, de maneira alguma, pelos atos dos usuários em seu
            Portal ou pelas informações nele registradas, correndo por conta e
            responsabilidade daquele que registrou as informações, a veracidade
            delas. Você está ciente e concorda que em momento algum a finalidade
            do Portal é a de prestar assessoria ou consultoria financeira,
            jurídica ou de comprovar regularidade comercial, mas tão somente
            permitir a um eventual devedor nele registrado, oportunidades
            diferenciadas para quitação do débito.
          </p>
          <h3>
            III – A titularidade autoral e propriedade intelectual do Portal
          </h3>
          <p>
            O Tribanco é exclusivo titular de seu nome comercial, marca, nome
            empresarial ou nome de domínio, conteúdo das telas do Portal,
            programas, bancos de dados, redes e arquivos que integram o Portal,
            os quais estão protegidos por leis diversas, sendo vedada a sua
            utilização por qualquer terceiro, inclusive Você. É condição para
            que Você navegue no Portal que respeite os direitos de propriedade
            intelectual e os decorrentes da proteção de marcas, patentes e/ou
            desenhos industriais, depositados ou registrados pelo Tribanco ou
            por terceiros que porventura estejam ou estiveram, de alguma forma,
            disponíveis no Portal. Não há qualquer cessão ou transferência
            destes direitos a Você, salvo se expressa e formalmente contratado
            em instrumento próprio entre as partes. É proibida a reprodução,
            distribuição e divulgação, total ou parcial, dos textos, figuras,
            gráficos que compõem o presente Portal, sem prévia e expressa
            autorização do Tribanco. A utilização indevida de qualquer dos
            recursos apontados neste capítulo importará na sua responsabilidade
            civil e criminal, além da exclusão da sua conta no Portal, se houver
            tal funcionalidade (criação de conta) no Portal. Se, por qualquer
            razão, o Tribanco lhe autorizar expressamente a utilização do
            material do Portal para outros fins, esta não poderá ser transferida
            a terceiros, mesmo que vinculados a Você. Qualquer alteração
            realizada pelo Tribanco no Portal não poderá ser compreendida como
            reconhecimento de responsabilidade ou erro, mas mera conveniência do
            Tribanco, e não lhe ensejará nenhuma indenização. Na sua interação
            com o Portal, Você deterá seus direitos sobre os conteúdos que já
            possuírem quando os enviam ao Portal, tais como, mas não
            limitadamente, a comentários, vídeos, imagens, áudio e mensagens, e
            Você concede ao Tribanco, nesse ato, uma licença irrevogável,
            perpétua, mundial, irrestrita, isenta de royalties e não exclusiva
            de reprodução, adaptação, modificação, tradução, publicação,
            distribuição ou exibição no próprio Portal, possibilitando a melhor
            utilização da ferramenta, maior divulgação de algum produto, serviço
            ou atividade ligada ao Portal. Quaisquer sugestões de alteração no
            Portal que Você faça e que, a critério do Tribanco, sejam
            implementadas, partem do pressuposto que de Você cedeu ao Tribanco
            referida sugestão de melhoria para o funcionamento do Portal, e Você
            nada poderá reclamar neste sentido, nem mesmo indenização, redução
            de valores devidos, dentre outros, ficando a alteração do Portal sob
            titularidade autoral do Tribanco.
          </p>
          <h3>IV – Ausência de responsabilidade do Tribanco</h3>
          <p>
            O Tribanco não alimenta nem controla, de qualquer forma, o conteúdo
            ou a exatidão das informações lançadas no Portal, não respondendo,
            desta forma, por prejuízos, perdas ou danos decorrentes do seu
            acesso ao Portal. De igual forma, o Tribanco não pode ser
            responsabilizado por qualquer dano, prejuízo ou perda do seu
            equipamento quando em conexão com o Portal, causados por falhas no
            sistema, no servidor ou na conexão à Internet, ainda que decorrentes
            de condutas de terceiros, inclusive por ações de softwares
            maliciosos como vírus, cavalos de tróia, e outros que possam, de
            algum modo, danificar o equipamento ou a sua conexão, bem como a
            transferência de dados, arquivos, imagens, textos, áudios ou vídeos
            contidos nele. A responsabilidade pelas informações lançadas no
            Portal é exclusivamente daquele que as alimentou no sistema, ficando
            o Tribanco absolutamente isento de qualquer responsabilidade, com o
            que Você concorda sem restrições.
          </p>
          <h3>V – Política de Privacidade</h3>
          <p>
            Além destes Termos de Uso, Você também deve estar ciente e concordar
            com nossa Política de Privacidade, que normatiza o tratamento das
            informações de cadastro e demais informações e dados coletados. É
            condição para sua navegação no nosso Portal que Você aceite e
            concorde com nossa Política de Privacidade.
          </p>
          <h3>VI – A sua interação com o Portal</h3>
          <p>
            Para que a finalidade do Portal seja alcançada, Você autoriza
            expressamente o Tribanco a utilizar todos os canais de comunicação
            que Você fornecer ao Portal, tais como e-mail, ligação telefônica ou
            envio de mensagem SMS. É indispensável, sob as penas da lei, o que
            Você declara conhecer e aceitar, que o preenchimento de seus dados
            sejam verdadeiros, pois são eles que possibilitarão a comunicação
            com Você. O Tribanco se exime de qualquer responsabilidade caso a
            comunicação seja inviabilizada porque Você não prestou dados
            verdadeiros ou corretos.
          </p>
          <h3>VI – Suas obrigações perante o Tribanco e o Portal</h3>
          <p>
            Você se declara maior e capaz, na forma da lei, para acessar o
            Portal, e se obriga a navegar nele dentro dos limites da ferramenta
            e em observância a princípios morais, legais e éticos. Todas as
            informações que Você fornecer ao Portal poderão não ser conferidas
            pelo Tribanco e devem corresponder à verdade, sob pena de Você
            indenizar os danos que vier a causar ao Tribanco ou a terceiros.
            Você deverá observar e manter em estrito sigilo dos seus dados
            informados no Portal, não divulgando ou compartilhando com quem quer
            que seja. Em caso de violação, por terceiros, de seus dados, Você
            deve comunicar ao Tribanco imediatamente, pelos meios informados no
            Portal, respondendo pelos prejuízos experimentados pelo Tribanco ou
            terceiros até que efetivamente o faça. Caso, por sua ação ou
            omissão, venha a causar danos ao Tribanco ou terceiros, deverá
            responder por eles integralmente, independente do valor verificado.
          </p>
          <h3>VII - Nossas obrigações perante Você e o Portal</h3>
          <p>
            Nós envidaremos nossos melhores esforços para manter o Portal ativo
            e navegável, com funcionalidades expostas de maneira clara,
            completa, precisa e suficiente de modo que exista a exata percepção
            das operações realizadas, garantindo, dentro do possível e
            necessário, a confidencialidade das informações. Todavia, Você
            concorda que poderá não ser possível evitar o ataque ao ambiente do
            Portal por terceiros, o que vai além dos esforços empenhados e do
            estado atual da tecnologia, hipótese que não se falará em
            responsabilidade do Tribanco.
          </p>
          <h3>VIII – O que está disponível para Você no nosso Portal</h3>
          <p>
            Você já sabe que a finalidade do nosso Portal é aproximar credores e
            devedores, oferecendo meios e facilidades para quitação dos débitos
            nele registrados. Todas as informações de registro das dívidas e
            condições facilitadas de pagamento são definidas pelo respectivo
            credor, de forma que o Tribanco não tem qualquer gestão neste
            conteúdo. Acaso Você identifique algum débito em seu nome, poderá
            promover a busca no Portal e pesquisar condições mais benéficas para
            quitação de referido débito, dentro das modalidades disponibilizadas
            para aquela operação. A quitação do débito será conferida pelo
            próprio credor. A critério do Tribanco, verificado qualquer ato ou
            tentativa de ato que viole as condições de utilização do Portal,
            suas informações e ou condições de negociação poderão ser excluídas
            ou suspensas, sem que isso implique em qualquer direito de
            indenização contra o Tribanco. O Portal não se presta a realização
            de consultas como mecanismo de verificação do nome do interessado em
            sistemas de proteção ao crédito, pois, tão somente checa se existe
            débito pendente com os credores filiados ao Portal. Se houver
            consultas e procedimentos controlados por terceiros inseridos no
            Portal poderão demandar pagamento de taxas ou tarifas. Tais encargos
            devem ser recolhidos por Você conforme o caso, pelos meios
            disponibilizados pelo Portal ou por terceiros. O Tribanco não é
            responsável pela exigibilidade dos títulos que deram ensejo ao
            débito registrado no Portal, sendo de estrita e exclusiva
            responsabilidade do credor, bem como não é responsável pelo
            resultado e sua experiência na utilização dos serviços e produtos
            divulgados no Portal. Ficam vedadas a publicação de conteúdos que
            violem estes Termos ou a Política de Privacidade aplicável, além das
            normas aplicáveis, podendo o Tribanco excluir tais publicações
            independente de qualquer formalidade, inclusive mas sem se limitar
            as publicações que versarem sobre ofensa à honra, imagem, reputação
            e dignidade de terceiros; pornografia, pedofilia, e outras
            modalidades de satisfação sexual; racismo ou discriminação de
            qualquer natureza; bullying, stalking ou qualquer outra espécie de
            constrangimento ilegal ou assédio; manifesta violação a direito
            autoral ou direito de imagem; utilização de marcas, símbolos,
            logotipos ou emblemas de terceiros; instigação ou apologia à prática
            de crimes, como tráfico ou uso de entorpecentes, estupro, homicídio,
            estelionato, dentre outros; manifesta prática de ato contrário à
            lei, à ordem pública ou aos bons costumes; uso da violência,
            disseminação de ódio ou qualquer outra forma de agressão ao bem
            estar físico de alguém; atividade comercial similar à do nosso
            Portal ou que o utilize para angariar recursos por publicidade de
            terceiros ao invés de praticar a interação regular do ambiente;
            erros ou suspeita de equívocos; conteúdo político partidário. O
            Tribanco disponibilizará canais de comunicação para que Você nos
            contate em caso de dúvidas ou denúncia de conteúdo vedado/impróprio.
          </p>
          <h3>IX – Fale conosco</h3>
          <p>
            Qualquer dúvida que Você venha a ter sobre o Portal poderão ser
            reportadas ao Tribanco pelo telefone 0800 979 3355. Não hesite em
            nos contatar!
          </p>
          <h3>X – Alterações supervenientes</h3>
          <p>
            Estes Termos e até mesmo a Política de Privacidade poderão ser
            alterados pelo Tribanco a qualquer tempo, independente de prévia
            comunicação. Caso, após as alterações, Você continue a utilizar o
            nosso Portal, vamos entender que Você a elas anuiu. Recomendamos
            visitar sempre nosso espaço dedicado aos Termos de Uso e Política de
            Privacidade para manter-se atualizado.
          </p>
          <h3>XI – Disposições finais</h3>
          <p>
            Nenhum ato será tido por novação ou qualquer outro meio de extinção
            de obrigações, se não consignado expressamente. Caso qualquer
            disposição destes Termos seja considerada ilegítima por autoridade
            da sua localidade, as demais condições permanecerão em pleno vigor e
            efeito.
          </p>
          <h3>XII – Foro e legislação</h3>
          <p>
            Estes termos estão sujeitos à legislação brasileira, ficando eleito
            o foro da comarca de Uberlândia-MG para dirimir as controvérsias
            dele decorrentes, com expressa renúncia de qualquer outro, por mais
            privilegiado que seja.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Sobre",
  data: () => ({
    title: "",
  }),
  methods: {},
  watch: {
    $route(to) {
      if (to.query.title == "Home") {
        window.location.href = "/";
        return;
      }
      this.title = to.query.title;
    },
  },
  created() {
    this.title = this.$route.query.title;
    this.banco = this.$route.query.banco;
  },
  computed: {},
};
</script>